import * as actions from "./actions";
import * as cloud from "../ajax/cloud";

export function fetchPairingCode({ xmppLogin, deviceName }) {
  return async (dispatch) => {
    try {
      dispatch(actions.fetchPairingCodeRequest());
      const pairingCode = await cloud.generatePairingCode({
        xmppLogin,
        deviceName
      });
      dispatch(actions.fetchPairingCodeSuccess(pairingCode));
    } catch (error) {
      dispatch(actions.fetchPairingCodeFailure(error.toString()));
    }
  };
}
